/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($){
  $('.DropdownLink').on('click', function(e){
    e.preventDefault();
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).closest('.Linklist__Item_link').next().slideToggle();
    }
    else{
      $('.DropdownLink').removeClass('active');
      $(this).toggleClass('active');
      $('.Collection_DropdownMenu').slideUp();
      $(this).closest('.Linklist__Item_link').next().slideToggle();
    }
  })
})

window.addEventListener('pplrAddToCartCompleted' , function(e) {
       //This function is triggered after a product is added to the cart
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));

  $('a[data-drawer-id="sidebar-cart"]')[0].click();
})